var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27682 3.50483L3.81617 9.08955L9.40089 14.6743C10.0214 15.2948 10.0214 16.2876 9.40089 16.9082C8.78037 17.5287 7.78747 17.5287 7.16694 16.9082L0.465394 10.2065C-0.155131 9.58598 -0.155131 8.59313 0.465394 7.97261L7.16694 1.27094C7.78747 0.650411 8.78037 0.650411 9.40089 1.27094C9.89731 1.89146 9.89734 2.8843 9.27682 3.50483Z",
    fill: "#787893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftGrey);
export default __webpack_public_path__ + "static/media/chevron-left-grey.7a510b0072336b149cdd87684a365ec6.svg";
export { ForwardRef as ReactComponent };